export const moduleName = 'category';